<template>
  <div class="table">
    <div class="table-header">
      <span class="header-item header-item__1">参与人</span>
      <span class="header-item header-item__2">参与时间</span>
      <span class="header-item header-item__3">参与进度</span>
    </div>
    <div class="table-main">
      <div class="table-content" v-if="recordList.length">
        <div class="content-ul" v-for="(item,index) in recordList" :key="index">
          <div class="content-item content-item__1">{{item.inviteeMobile | pwdCard}}</div>
          <div class="content-item content-item__2">{{item.inviteePartakeTime}}</div>
          <div class="content-item content-item__3 content-item-order" v-if="item.inviteeStatus === 1">
            <div class="pending-order">待下单</div>
            <div class="recommend-order">推荐下单 即领奖励</div>
          </div>
          <div class="content-item content-item__3 content-item-end" v-else-if="item.inviteeStatus === 3">{{item.inviteeStatusDesc}}</div>
          <div class="content-item content-item__3 content-item-cash" v-else>{{item.inviteeStatusDesc}}</div>
        </div>
      </div>
      <div class="table-main-empty" v-else>
        <img class="empty-img" src="@/assets/initiate/none.png" alt="">
        <div class="empty-text">您还没有好友参加活动</div>
      </div>
    </div>
  </div>
</template>

<script>

import { isPhone } from '@/utils/validate'
export default {
  name: 'Table',
  props: {
    recordList: {
      type: Array,
      required: false,
    },
  },
  data(){
    return {
   
    }
  },

  mounted(){

  },
  methods:{

  },
  components:{

  },
  filters: {
    pwdCard: function (value) {
      if(isPhone(value)){
        const start = value.slice(0, 3)
        const end = value.slice(-4)
        let strs = value
        strs = strs.replace(/./g, '*')
        const newStr = start + "" + strs.slice(3, -4) + "" + end
        return newStr
      }else{
        return '****'
      }
    }
  }
}
</script>


<style lang="scss" scoped>
.table{
  height: 420px;
  background: #FFFBF9;
  border-radius: 32px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  .table-header{
    text-align: center;
    font-size: 28px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #111111;
    flex: 0 0 88px;
    display: flex;
    .header-item{
      line-height: 88px;
      display: inline-block;
      // width: 33%;
      height: 88px;
      background: #F5F6F7;
    }
    .header-item__1{
      flex: 5;
    }
    .header-item__2{
      flex: 5;
    }
    .header-item__3{
      flex: 6;
    }
  }
  .table-main{
    flex: 1;
    overflow-y: auto;
    .table-main-empty{
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      .empty-img{
        width: 200px;
        margin-bottom: 16px;
      }
      .empty-text{
        width: 100%;
        height: 40px;
        font-size: 28px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #969799;
        line-height: 40px;
        text-align: center;
      }
    }
    .table-content{
      text-align: center;
      .content-ul{
        font-size: 28px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #111111;
        width: 100%;
        height: 120px;
        border-bottom: 1px solid #D8D8D8;
        display: flex;
        .content-item{
          // flex: 1;
          font-size: 22px;
          overflow: hidden;
          height: 120px;
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
        }
        .content-item-end{
          color: #979797;
        }
        .content-item-cash{
          color: #FF6A39;
        }
        .content-item__1{
          flex: 5;
        }
        .content-item__2{
          flex: 5;
        }
        .content-item__3{
          flex: 6;
        }
        .content-item-order{  
          font-family: PingFangSC-Regular, PingFang SC;
          line-height: 0;
          .pending-order{ 
            font-size: 24px;
            font-weight: 400;
            color: #979797;
            line-height: 24px;
            margin-bottom: 16px;
          }
          .recommend-order{
            font-size: 22px;
            font-weight: 500;
            color: #FF1600;
            line-height: 22px;
            font-family: PingFangSC-Medium, PingFang SC;
          }
        }
      }
    }
  }
}
</style>